import { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import { useStores } from '../../../utils'
import { ISkillBase } from '../../../types'
import { InputSearchGroupWithDropDown } from '../InputSearchGroupWithDropDown'
import { SkillSelectionField } from '../SkillSelectionField'
import { SkillCreationField } from '../SkillCreationField'

type Props = {
  selectedSkills: ISkillBase[]
  setFieldValue: (Skills: ISkillBase[]) => void
}

export const SkillSearchField: FC<Props> = observer(({ selectedSkills, setFieldValue }) => {
  const { t } = useTranslation(['search'])
  const { companies } = useStores()
  const [currentMode, setCurrentMode] = useState<'none' | 'select' | 'create'>('none')
  const [searchResult, setSearchResult] = useState<ISkillBase[]>([])
  const [searchWord, setSearchWord] = useState<string>('')

  const searchResultExcludingSelected = searchResult.filter((skill) => {
    const isSelected = selectedSkills.some((s) => s.slug === skill.slug)
    return !isSelected
  })

  const onInputFinished = async (finishedSearchWord: string) => {
    setSearchWord(finishedSearchWord)
    const skills = await companies.fetchSkills({
      searchWord: finishedSearchWord,
      limit: 20,
    })
    setSearchResult(skills)
  }

  const selectSkill = (skill: ISkillBase) => {
    const isSelected = selectedSkills.some((s) => s.slug === skill.slug)

    if (isSelected) {
      return
    } // 選択済みの skill の場合は 何もしない

    const newSkills = selectedSkills.concat(skill)
    setFieldValue(newSkills)
    setCurrentMode('none')
  }

  return (
    <div>
      <InputSearchGroupWithDropDown
        isDropDownOpen={currentMode !== 'none'}
        onInputFinished={onInputFinished}
        closeDropDown={() => setCurrentMode('none')}
        openDropDown={() => setCurrentMode('select')}
        placeholder={t('スキルを検索')}
      >
        {/* ---------- スキル選択 ------------*/}
        {currentMode === 'select' && (
          <SkillSelectionField
            searchWord={searchWord}
            skills={searchResultExcludingSelected}
            onClickOption={(skill) => selectSkill(skill)}
            onClickCreateButton={() => setCurrentMode('create')}
          />
        )}
        {/* ---------- スキル選択 ------------*/}

        {/* ---------- スキル作成 ------------*/}
        {currentMode === 'create' && (
          <SkillCreationField
            searchWord={searchWord}
            onCreateSkill={(skill) => selectSkill(skill)}
            onClickCancelButton={() => setCurrentMode('select')}
          />
        )}
        {/* ---------- スキル作成 ------------*/}
      </InputSearchGroupWithDropDown>
    </div>
  )
})
